export default __webpack_public_path__ + "static/media/fire.d6d56ff5.svg";